<template>
    <v-dialog v-model="show_dialog" ref="save_poll_dialog" scrollable persistent max-width="650px" :fullscreen="$vuetify.breakpoint.smAndDown">
        <v-form ref="savePollForm" method="post" :action="form.action" v-on:success="success_save_poll">
            <v-card>
                <v-card-title
                    class="headline blue darken-2 white--text"
                    primary-title
                >
                    <div v-if="is_new_item">{{$t('event.poll.create_event_poll')}}</div>
                    <div v-else>{{$t('event.poll.edit_event_poll')}}</div>
                </v-card-title>
                <v-card-text ref="save_event_poll_wrapper" id="save_event_poll_wrapper" class="v-dialog-body">
                    <input type="hidden" name="is_new_item" :value="is_new_item?1:0">
                    <input type="hidden" name="poll_id" :value="form.data.poll_id">
                    <template v-for="(item, index) in form.data.start_date">
                        <input type="hidden" :name="'start_time_options[' + index + ']'" :value="form.data.start_date[index]">
                        <input type="hidden" :name="'end_time_options[' + index + ']'" :value="form.data.end_date[index]">
                    </template>
                    <template v-for="(item, index) in form.data.location">
                        <input type="hidden" :name="'location_options[' + index + ']'" :value="form.data.location[index]">
                    </template>
                    <template v-for="(item, index) in form.data.activity">
                        <input type="hidden" :name="'activity_options[' + index + ']'" :value="form.data.activity[index]">
                    </template>
                    <input type="hidden" name="remove_time" :value="form.data.remove_time">
                    <input type="hidden" name="remove_location" :value="form.data.remove_location">
                    <input type="hidden" name="remove_activity" :value="form.data.remove_activity">

                    <v-container grid-list-md>
                        <v-layout wrap>
                            <v-flex xs12 v-show="form.errors.general">
                                <v-alert
                                        ref="general"
                                        :value="form.errors.general!==''"
                                        type="error"
                                >
                                    {{form.errors.general}}
                                </v-alert>
                            </v-flex>

                            <v-flex xs12>
                                <v-text-field
                                        ref="title"
                                        :label="$t('event.title')"
                                        v-model="form.data.event_title"
                                        :error-messages="form.errors.title"
                                        name="title"
                                >
                                </v-text-field>
                            </v-flex>


                            <v-flex xs12>
                                <h3>Time Options:</h3>
                                <div>
<!--                                    <v-checkbox-->
<!--                                            v-model="form.data.time_is_mandatory"-->
<!--                                            :label="$t('general.is_mandatory')"-->
<!--                                            color="indigo"-->
<!--                                            name="time_is_mandatory"-->
<!--                                            :value="1"-->
<!--                                            hide-details-->
<!--                                            :disabled="!has_time_options"-->
<!--                                    />-->
                                    <v-checkbox
                                            v-model="form.data.time_is_multiple"
                                            :label="$t('general.is_multiple')"
                                            color="indigo"
                                            :value="1"
                                            name="time_is_multiple"
                                            hide-details
                                            class="mb-2"
                                            :disabled="!has_time_options"
                                    />
                                    <v-btn small color="success" @click="add_time_option">{{$t('action.add_option')}}</v-btn>
                                </div>
                            </v-flex>

                            <template v-for="(item, index) in form.data.start_date">
                                <v-flex xs10>
                                    <v-layout wrap>
                                        <v-flex xs7 sm4>
                                            <v-menu
                                                    :ref="`start_date_wp_` + index"
                                                    :close-on-content-click="false"
                                                    v-model="start_date_wp[index]"
                                                    :nudge-right="40"
                                                    :return-value.sync="start_date[index]"
                                                    lazy
                                                    transition="scale-transition"
                                                    offset-y
                                                    full-width
                                                    min-width="290px"
                                            >
                                                <v-text-field
                                                        slot="activator"
                                                        v-model="start_date[index]"
                                                        :value="format_date(start_date[index])"
                                                        :label="$t('event.start_time')"
                                                        hide-details
                                                        readonly
                                                />
                                                <v-date-picker
                                                        v-model="start_date[index]"
                                                        @input="$refs['start_date_wp_'+index][0].save(start_date[index]); start_date_wp[index] = false;update_end_time(index);update_start_data();"
                                                />
                                            </v-menu>
                                        </v-flex>
                                        <v-flex xs5 sm2>
                                            <v-dialog
                                                    :ref="`start_time_wp_` + index"
                                                    v-model="start_time_wp[index]"
                                                    :return-value.sync="start_time[index]"
                                                    persistent
                                                    lazy
                                                    full-width
                                                    width="290px"
                                            >
                                                <v-text-field
                                                        slot="activator"
                                                        :value="format_time(start_time[index])"
                                                        hide-details
                                                        readonly
                                                />
                                                <v-time-picker
                                                        v-if="start_time_wp[index]"
                                                        v-model="start_time[index]"
                                                        full-width
                                                >
                                                    <v-spacer />
                                                    <v-btn flat color="primary" @click="start_time_wp[index] = false">{{$t('action.cancel')}}</v-btn>
                                                    <v-btn flat color="primary" @click="$refs['start_time_wp_'+index][0].save(start_time[index]);update_end_time(index);update_start_data();">{{$t('action.ok')}}</v-btn>
                                                </v-time-picker>
                                            </v-dialog>
                                        </v-flex>

                                        <v-flex xs7 sm4>
                                            <v-menu
                                                    :ref="'end_date_wp_' + index"
                                                    :close-on-content-click="false"
                                                    v-model="end_date_wp[index]"
                                                    :nudge-right="40"
                                                    :return-value.sync="end_date[index]"
                                                    lazy
                                                    transition="scale-transition"
                                                    offset-y
                                                    full-width
                                                    min-width="290px"
                                            >
                                                <v-text-field
                                                        slot="activator"
                                                        v-model="end_date[index]"
                                                        :value="format_date(end_date[index])"
                                                        :label="$t('event.end_time')"
                                                        hide-details
                                                        readonly
                                                />
                                                <v-date-picker
                                                        v-model="end_date[index]"
                                                        @input="$refs['end_date_wp_' + index][0].save(end_date[index]); end_date_wp[index] = false;update_time_duration(index);update_end_data();"
                                                />
                                            </v-menu>
                                        </v-flex>

                                        <v-flex xs5 sm2>
                                            <v-dialog
                                                    :ref="'end_time_wp_' + index"
                                                    v-model="end_time_wp[index]"
                                                    :return-value.sync="end_time[index]"
                                                    persistent
                                                    lazy
                                                    full-width
                                                    width="290px"
                                            >
                                                <v-text-field
                                                        slot="activator"
                                                        :value="format_time(end_time[index])"
                                                        hide-details
                                                        readonly
                                                />
                                                <v-time-picker
                                                        v-if="end_time_wp[index]"
                                                        v-model="end_time[index]"
                                                        full-width
                                                >
                                                    <v-spacer />
                                                    <v-btn flat color="primary" @click="end_time_wp[index] = false">{{$t('action.cancel')}}</v-btn>
                                                    <v-btn flat color="primary" @click="$refs['end_time_wp_' + index][0].save(end_time[index]);update_time_duration(index);update_end_data();">{{$t('action.ok')}}</v-btn>
                                                </v-time-picker>
                                            </v-dialog>
                                        </v-flex>

                                    </v-layout>

                                    <div :ref="'time_' + index">
                                        <div class="form-errors" v-show="form.errors['time_' + index]">
                                            {{form.errors['time_' + index]}}
                                        </div>
                                    </div>

                                </v-flex>

                                <v-flex xs2>
                                    <v-btn color="primary" @click="remove_time_option(index)"><v-icon>delete</v-icon></v-btn>
                                </v-flex>
                            </template>

                            <v-flex xs12 class="mb-2" />

                            <v-flex xs12>
                                <h3>Location Options:</h3>
                                <div>
<!--                                    <v-checkbox-->
<!--                                            v-model="form.data.location_is_mandatory"-->
<!--                                            :label="$t('general.is_mandatory')"-->
<!--                                            color="indigo"-->
<!--                                            name="location_is_mandatory"-->
<!--                                            :value="1"-->
<!--                                            hide-details-->
<!--                                            :disabled="!has_location_options"-->
<!--                                    />-->
                                    <v-checkbox
                                            v-model="form.data.location_is_multiple"
                                            :label="$t('general.is_multiple')"
                                            color="indigo"
                                            :value="1"
                                            name="location_is_multiple"
                                            hide-details
                                            class="mb-2"
                                            :disabled="!has_location_options"
                                    />
                                    <v-btn small color="success" @click="add_location_option">{{$t('action.add_option')}}</v-btn>
                                </div>
                            </v-flex>

                            <template v-for="(item, index) in form.data.location">
                                <v-flex xs10>
                                    <v-text-field
                                            v-model="form.data.location[index]"
                                            :label="$t('event.location')"
                                            :name="'location[' + index + ']'"
                                            hide-details
                                    />
                                </v-flex>
                                <v-flex xs2>
                                    <v-btn color="primary" @click="remove_location_option(index)"><v-icon>delete</v-icon></v-btn>
                                </v-flex>
                            </template>

                            <v-flex xs12 class="mb-2" />

                            <v-flex xs12>
                                <h3>Activity Options:</h3>
                                <div>
<!--                                    <v-checkbox-->
<!--                                            v-model="form.data.activity_is_mandatory"-->
<!--                                            :label="$t('general.is_mandatory')"-->
<!--                                            color="indigo"-->
<!--                                            name="activity_is_mandatory"-->
<!--                                            :value="1"-->
<!--                                            hide-details-->
<!--                                            :disabled="!has_activity_options"-->
<!--                                    />-->
                                    <v-checkbox
                                            v-model="form.data.activity_is_multiple"
                                            :label="$t('general.is_multiple')"
                                            color="indigo"
                                            :value="1"
                                            name="activity_is_multiple"
                                            hide-details
                                            class="mb-2"
                                            :disabled="!has_activity_options"
                                    />
                                    <v-btn small color="success" @click="add_activity_option">{{$t('action.add_option')}}</v-btn>
                                </div>
                            </v-flex>

                            <template v-for="(item, index) in form.data.activity">
                                <v-flex xs10>
                                    <v-text-field
                                            v-model="form.data.activity[index]"
                                            :label="$t('event.activity')"
                                            :name="'activity[' + index + ']'"
                                            hide-details
                                    />
                                </v-flex>
                                <v-flex xs2>
                                    <v-btn color="primary" @click="remove_activity_option(index)"><v-icon>delete</v-icon></v-btn>
                                </v-flex>
                            </template>

                        </v-layout>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn color="blue darken-1" flat @click="close_dialog">{{$t('action.close')}}</v-btn>
                    <v-btn color="blue darken-1" flat type="submit" :loading="form.loading">{{$t('action.save')}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-form>
    </v-dialog>
</template>

<script>
    import {UrlServices} from "~/utils/url-manager";
    import FormHandling from "~/utils/data/form-handling";
    import Utils from "~/utils/index";

    export default {
        name: "SaveEventPollDialog",
        props: {
            show_dialog: Boolean,
            save_success_callback: Function,
            is_new_item: Boolean,
            post_fields: {
                type: Boolean,
                default: false
            },
            poll_item: Object
        },
        data() {
            return {
                form: {
                    form_handling_object: null,
                    action: UrlServices.createUrl({name: "api_event_poll_save"}),
                    loading: false,
                    data: {
                        poll_id: 0,
                        event_title: "",
                        start_date: {},
                        end_date: {},
                        location: {},
                        activity: {},
                        remove_time: [],
                        remove_location: [],
                        remove_activity: [],
                        time_is_mandatory: 0,
                        time_is_multiple: 0,
                        location_is_mandatory: 0,
                        location_is_multiple: 0,
                        activity_is_mandatory: 0,
                        activity_is_multiple: 0,
                    },
                    errors: {
                        general: "",
                        title: "",
                        time: {}
                    }
                },
                rules: {
                    required: value => (!!value) || this.$t('form.field_required'),
                },
                wp: false,
                start_date_wp: {},
                start_time_wp: {},
                start_date: {},
                start_time: {},
                end_date_wp: {},
                end_time_wp: {},
                end_date: {},
                end_time: {},
                time_duration: {}
            };
        },
        computed: {
            has_time_options() {
                return !!_.size(this.form.data.start_date);
            },
            has_location_options() {
                return !!_.size(this.form.data.location);
            },
            has_activity_options() {
                return !!_.size(this.form.data.activity);
            }
        },
        methods: {
            format_date(date) {
                return getApp.$moment(date).format('YYYY-MM-DD');
            },
            format_time(time) {
                return getApp.$moment(time, 'HH:mm').format('hh:mm A');
            },
            close_dialog() {
                this.$emit('update:show_dialog', false);
                this.update_poll_data(this.empty_poll_item);
                this.form.form_handling_object.clearErrors();
                // reset the scroll position when close the dialog
                this.$refs['save_event_poll_wrapper'].scrollTop = 0;
            },
            add_time_option() {
                let start_moment = getApp.$moment();
                let end_moment = start_moment.clone().add(7200, 'second');

                let uid = Utils.getUniqueId();

                this.form.errors['time_' + uid] = "";

                this.start_date[uid] = this.start_date[Object.keys(this.start_date)[Object.keys(this.start_date).length - 1]]||start_moment.format('YYYY-MM-DD');
                this.start_time[uid] = this.start_time[Object.keys(this.start_time)[Object.keys(this.start_time).length - 1]]||start_moment.format('HH:mm');
                this.end_date[uid] = this.end_date[Object.keys(this.end_date)[Object.keys(this.end_date).length - 1]]||end_moment.format('YYYY-MM-DD');
                this.end_time[uid] = this.end_time[Object.keys(this.end_time)[Object.keys(this.end_time).length - 1]]||end_moment.format('HH:mm');

                this.update_start_data();
                this.update_end_data();
            },
            remove_time_option(index) {
                delete this.start_date[index];
                delete this.start_time[index];
                delete this.end_date[index];
                delete this.end_time[index];

                if(!isNaN(index)){
                    this.form.data.remove_time.push(index);
                }

                this.update_start_data();
                this.update_end_data();
            },
            add_location_option() {
                let uid = Utils.getUniqueId();
                this.$set(this.form.data.location, uid, "")
            },
            remove_location_option(index) {
                delete this.form.data.location[index];
                if(!isNaN(index)){
                    this.form.data.remove_location.push(index);
                }
                this.form.data.location = _.extend({}, this.form.data.location);
            },
            add_activity_option() {
                let uid = Utils.getUniqueId();
                this.form.data.activity[uid] = "";
                this.form.data.activity = _.extend({}, this.form.data.activity);
            },
            remove_activity_option(index) {
                delete this.form.data.activity[index];
                if(!isNaN(index)){
                    this.form.data.remove_activity.push(index);
                }
                this.form.data.activity = _.extend({}, this.form.data.activity);
            },
            update_poll_data(new_poll_item) {

                let me = this;

                let poll_id = new_poll_item['id'];
                let event_title = new_poll_item['title'];

                let start_date = {};
                let start_time = {};
                let end_date = {};
                let end_time = {};
                let start_time_wp = {};
                let start_date_wp = {};
                let end_date_wp = {};
                let end_time_wp = {};
                let time_duration = {};
                let locations = {};
                let activities = {};

                let time_question = new_poll_item['time_question'];
                let time_is_multiple = 0;
                let time_is_mandatory = 0;
                if(time_question){
                    time_is_multiple = time_question['is_multiple'];
                    time_is_mandatory = time_question['is_mandatory'];

                    let time_options = time_question['options'];
                    _.each(time_options, function(item) {
                        let option_id = item['id'];

                        let start_moment = getApp.$moment(item.value.start_time, 'X');
                        let end_moment = getApp.$moment(item.value.end_time, 'X');
                        let duration = getApp.$moment.duration(end_moment.diff(start_moment));

                        start_date[option_id] = start_moment.format('YYYY-MM-DD');
                        start_time[option_id] = start_moment.format('HH:mm');
                        end_date[option_id] = end_moment.format('YYYY-MM-DD');
                        end_time[option_id] = end_moment.format('HH:mm');
                        start_time_wp[option_id] = false;
                        start_date_wp[option_id] = false;
                        end_date_wp[option_id] = false;
                        end_time_wp[option_id] = false;
                        time_duration[option_id] = duration.asSeconds();

                        me.form.errors['time_' + option_id] = "";
                    });
                }

                let location_question = new_poll_item['location_question'];
                let location_is_multiple = 0;
                let location_is_mandatory = 0;
                if(location_question){
                    location_is_multiple = location_question['is_multiple'];
                    location_is_mandatory = location_question['is_mandatory'];

                    let location_options = location_question['options'];
                    _.each(location_options, function(item) {
                        let option_id = item['id'];
                        locations[option_id] = item.value;
                    });
                }

                let activity_question = new_poll_item['activity_question'];
                let activity_is_multiple = 0;
                let activity_is_mandatory = 0;
                if(activity_question){
                    activity_is_multiple = activity_question['is_multiple'];
                    activity_is_mandatory = activity_question['is_mandatory'];

                    let activity_options = activity_question['options'];
                    _.each(activity_options, function(item) {
                        let option_id = item['id'];
                        activities[option_id] = item.value;
                    });
                }

                this.form.data = {
                    poll_id: poll_id,
                    event_title: event_title,
                    start_date: {},
                    end_date: {},
                    location: locations,
                    activity: activities,
                    remove_time: [],
                    remove_location: [],
                    remove_activity: [],
                    time_is_mandatory: time_is_mandatory,
                    time_is_multiple: time_is_multiple,
                    location_is_mandatory: location_is_mandatory,
                    location_is_multiple: location_is_multiple,
                    activity_is_mandatory: activity_is_mandatory,
                    activity_is_multiple: activity_is_multiple,
                };

                this.start_date = start_date;
                this.start_time = start_time;
                this.end_date = end_date;
                this.end_time = end_time;
                this.start_time_wp = start_time_wp;
                this.start_date_wp = start_date_wp;
                this.end_date_wp = end_date_wp;
                this.end_time_wp = end_time_wp;
                this.time_duration = time_duration;

            },
            update_start_data() {
                let obj = {};
                let me = this;
                _.each(this.start_date, function(val, index){
                    obj[index] = me.start_date[index] + ' ' + me.start_time[index];
                });
                this.form.data.start_date = obj;
            },
            update_end_data() {
                let obj = {};
                let me = this;
                _.each(this.end_date, function(val, index){
                    obj[index] = me.end_date[index] + ' ' + me.end_time[index];
                });
                this.form.data.end_date = obj;
            },
            update_end_time(index) {
                let end_moment = getApp.$moment(this.start_date[index] + ' ' + this.start_time[index], 'YYYY-MM-DD HH:mm');
                end_moment.add(this.time_duration[index], 'second');

                this.end_date[index] = end_moment.format('YYYY-MM-DD');
                this.end_time[index] = end_moment.format('HH:mm');
                this.update_end_data();
            },
            update_time_duration(index) {
                let start_moment = getApp.$moment(this.start_date[index] + ' ' + this.start_time[index], 'YYYY-MM-DD HH:mm');
                let end_moment = getApp.$moment(this.end_date[index] + ' ' + this.end_time[index], 'YYYY-MM-DD HH:mm');

                let duration = getApp.$moment.duration(end_moment.diff(start_moment));
                this.time_duration[index] = duration.asSeconds();
            },
            success_save_poll(data) {
                this.save_success_callback(data);
                this.close_dialog();
            },
            close_time_picker(index) {
                let me = this;
                me.start_time_wp[index] = false;

            }
        },
        beforeCreate() {
            this.empty_poll_item = {
                title: "",
                time_options: [],
                location_options: [],
                activity_options: [],
            };
        },
        watch: {
            // has_time_options: function(val) {
            //     if(!val){
            //         this.form.data.time_is_multiple = false;
            //         this.form.data.time_is_mandatory = false;
            //     }
            // },
            // has_location_options: function(val) {
            //     if(!val){
            //         this.form.data.location_is_multiple = false;
            //         this.form.data.location_is_mandatory = false;
            //     }
            // },
            // has_activity_options: function(val) {
            //     if(!val){
            //         this.form.data.activity_is_multiple = false;
            //         this.form.data.activity_is_mandatory = false;
            //     }
            // },
            poll_item: async function(new_poll_item) {
                if(new_poll_item == null){
                    new_poll_item = this.empty_poll_item;
                    this.form.form_handling_object.formReset();
                    await this.$nextTick();
                }
                this.update_poll_data(new_poll_item);
            },
            start_date: {
                handler(val, oldVal){
                    this.update_start_data();
                },
                deep: true
            },
            start_time: {
                handler(val){
                    this.update_start_data();
                },
                deep: true
            },
            end_date: {
                handler(val){
                    this.update_end_data();
                },
                deep: true
            },
            end_time: {
                handler(val){
                    this.update_end_data();
                },
                deep: true
            }
        },
        mounted() {
            let me = this;
            this.form.form_handling_object = new FormHandling(this, "savePollForm", this.form, "#save_event_poll_wrapper");
        }
    }
</script>

<style scoped>
    .form-errors {
        color: red;
    }
</style>